import defaultTable from '@/components/layout/defaultTable/DefaultTable.vue'
import pagination from '@/components/layout/pagination/Pagination.vue'
import { BToast } from 'bootstrap-vue'
import { mapState, mapActions } from 'vuex'
import constants from '@/util/constants'
import mensagens from '@/util/mensagens'
import util from '@/util'

export default {
  name: 'correspondente',
  components: {
    'default-table': defaultTable,
    'b-toast': BToast,
    pagination
  },

  computed: {
    ...mapState('usuarios', ['listaEstadosDisponiveis', 'formulario', 'dadosPerfil', 'dadosRetorno', 'flagsDeControle']),
    ...mapState('pagination', ['registrosPorPagina'])
  },

  data: () => {
    return {
      timeOutDigitacaoNocombo: null,

      comboTiposCorrespondentesDisponiveis: [],
      tipoCorrespondenteSelecionado: null,

      comboEstadosDisponiveis: [],
      estadoSelecionado: null,

      comboComarcasDisponiveis: [],
      comarcaSelecionada: null,

      listaEstadoComarcaVinculado: [],
      fieldsEstadoComarca: [
        { key: 'district.f_name', sortable: false, label: 'Comarca' },
        { key: 'district.state.f_name', sortable: false, label: 'Estado' },
        { key: 'opcoes', sortable: false, label: 'Opções' }
      ],
      componentePaginacao: {
        pagina: 1,
        registrosPorPagina: null,
        fonteDeDados: [],
        ultimaPagina: 1,
        totalRegistros: 0
      },
      camposFiltroPesquisa: {
        comarca: null
      },
      filtrosPesquisa: null
    }
  },

  mounted () {
    this.componentePaginacao.registrosPorPagina = this.registrosPorPagina
    this.limparListaErros()
    this.obterTiposCorrespondentesDisponiveis()
    this.obterEstadosDisponiveis()
    this.obterListaEstadoComarcasVinculados()
  },

  methods: {
    ...mapActions('usuarios', ['ActionDefinirListaEstados']),

    tabelaSemRegistros (item, type) {
      if (util.valorVazio(item) && type === 'row-empty') {
        return 'text-center'
      }
    },

    async obterTiposCorrespondentesDisponiveis () {
      const resposta = await this.axios.get('/correspondente/tipos')
      let listaTipos = resposta.data.retorno.dados
      this.comboTiposCorrespondentesDisponiveis = []
      for (let indice in listaTipos) {
        let tipos = listaTipos[indice]
        for (let id in tipos) {
          let tipo = tipos[id]
          this.comboTiposCorrespondentesDisponiveis.push({ label: tipo, code: id })
        }
      }
    },

    eventoDigitarBuscaPorEstado (valorDigitadoParaBusca, callbackFlagCarregamento) {
      this.limparListaErros()
      this.limparCamposDeComarca()

      clearTimeout(this.timeOutDigitacaoNocombo)
      let referenciaObjetoDaView = this

      this.timeOutDigitacaoNocombo = setTimeout(function () {
        referenciaObjetoDaView.obterEstadosDisponiveis(valorDigitadoParaBusca, callbackFlagCarregamento)
      }, constants.tempoParaAguardarDigitacaoNoCombo)
    },

    async obterEstadosDisponiveis (valorDigitadoParaBusca, callbackFlagCarregamento) {
      if (!util.valorEhNulo(callbackFlagCarregamento)) {
        callbackFlagCarregamento = true
      }
      let parametrosRequisicao = {
        'registrosPorPagina': constants.defaultRegistrosCombo,
        'filtros': { 'f_name': valorDigitadoParaBusca }
      }

      await this.ActionDefinirListaEstados(parametrosRequisicao)
      this.comboEstadosDisponiveis = this.listaEstadosDisponiveis.map(function (registro) {
        return { label: registro.f_name, code: registro.f_id }
      })
      callbackFlagCarregamento = false
    },

    eventoBuscarComarcasPeloEstado () {
      this.limparListaErros()

      if (util.valorVazio(this.estadoSelecionado)) {
        this.limparCamposDeComarca()
      } else {
        this.limparCamposDeComarca()
        this.obterComarcasDisponiveis()
      }
    },

    eventoDigitarBuscaPorComarca (valorDigitadoParaBusca, callbackFlagCarregamento) {
      this.limparListaErros()

      if (!util.valorVazio(this.estadoSelecionado)) {
        clearTimeout(this.timeOutDigitacaoNocombo)
        let referenciaObjetoDaView = this

        this.timeOutDigitacaoNocombo = setTimeout(function () {
          referenciaObjetoDaView.obterComarcasDisponiveis(valorDigitadoParaBusca, callbackFlagCarregamento)
        }, constants.tempoParaAguardarDigitacaoNoCombo)
      }
    },

    async obterComarcasDisponiveis (valorDigitadoParaBusca, callbackFlagCarregamento) {
      if (!util.valorEhNulo(callbackFlagCarregamento)) {
        callbackFlagCarregamento = true
      }
      let parametrosRequisicao = {
        'registrosPorPagina': constants.defaultRegistrosCombo,
        'filtros': { 'f_name': valorDigitadoParaBusca }
      }

      const resposta = await this.axios.post('/unidade-federativa/' + this.estadoSelecionado.code + '/comarcas', parametrosRequisicao)
      let listaComarcas = resposta.data.retorno.dados
      this.comboComarcasDisponiveis = []
      for (let indice in listaComarcas) {
        let comarca = listaComarcas[indice]
        this.comboComarcasDisponiveis.push({ label: comarca.f_name, code: comarca.f_id })
      }
      callbackFlagCarregamento = false
    },

    buscarRegistros () {
      this.filtrosPesquisa = this.camposFiltroPesquisa.comarca
      this.obterListaEstadoComarcasVinculados()
    },

    async obterListaEstadoComarcasVinculados () {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)

      let parametrosRequisicao = {
        'page': this.componentePaginacao.pagina,
        'registrosPorPagina': this.componentePaginacao.registrosPorPagina,
        'filtros': {
          'f_user': this.formulario.f_id,
          'f_district.f_name': this.filtrosPesquisa
        }
      }
      const resposta = await this.axios.post('/correspondente/comarcas', parametrosRequisicao)
      this.listaEstadoComarcaVinculado = resposta.data.retorno.dados
      this.componentePaginacao.fonteDeDados = resposta.data.retorno.paginacao
      this.componentePaginacao.ultimaPagina = resposta.data.retorno.paginacao.ultimaPagina
      this.componentePaginacao.totalRegistros = resposta.data.retorno.paginacao.totalRegistros

      this.definirFlagCarregandoDados(false, '')
    },

    async vincularComarca () {
      this.limparListaErros()
      this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)

      let estadoInformado = true
      let comarcaInformada = true

      if (util.valorVazio(this.estadoSelecionado)) {
        this.dadosRetorno.listaDeErros['f_state'] = 'Selecione um estado'
        estadoInformado = false
      }

      if (util.valorVazio(this.comarcaSelecionada)) {
        this.dadosRetorno.listaDeErros['f_district'] = 'Selecione uma comarca'
        comarcaInformada = false
      }

      if (estadoInformado && comarcaInformada) {
        let parametrosRequisicao = {
          'f_user': this.formulario.f_id,
          'f_district': this.comarcaSelecionada.code
        }
        const resposta = await this.axios.post('/correspondente/vincular-comarca', parametrosRequisicao)
        this.dadosRetorno.sucesso = resposta.data.retorno.sucesso
        this.dadosRetorno.mensagem = resposta.data.retorno.mensagem
        this.dadosRetorno.listaDeErros = resposta.data.retorno.listaDeErros

        this.tratarAposSalvarRegistro()
      }
      this.definirFlagManipulandoDados(false, '')
    },

    tratarAposSalvarRegistro () {
      if (this.dadosRetorno.sucesso) {
        util.criarAlertaToastDeSucesso(this, 'Aviso', 'Dados salvos com sucesso.')
        this.obterListaEstadoComarcasVinculados()
        this.resetarAutoComplete()
      } else {
        util.criarAlertaToastDeErro(this, 'Aviso', this.dadosRetorno.mensagem)
      }
    },

    async desvincularComarca (item) {
      this.limparListaErros()
      this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)

      const resposta = await this.axios.delete('/correspondente/' + this.formulario.f_id + '/desvincular-comarca/' + item.f_district)
      this.dadosRetorno.sucesso = resposta.data.retorno.sucesso
      this.dadosRetorno.mensagem = resposta.data.retorno.mensagem

      if (this.dadosRetorno.sucesso) {
        util.criarAlertaToastDeSucesso(this, 'Aviso', 'Dados salvos com sucesso.')
        this.resetarAutoComplete()
        this.obterListaEstadoComarcasVinculados()
      } else {
        util.criarAlertaToastDeErro(this, 'Aviso', this.dadosRetorno.mensagem)
      }
      this.definirFlagManipulandoDados(false, '')
    },

    resetarAutoComplete () {
      this.estadoSelecionado = null
      this.limparCamposDeComarca()
    },

    limparCamposDeComarca () {
      this.comboComarcasDisponiveis = []
      this.comarcaSelecionada = null
    },

    limparListaErros () {
      this.dadosRetorno.listaDeErros = {}
    },

    obterDadosPaginados (pagina, registrosPorPagina) {
      this.componentePaginacao.pagina = pagina
      this.componentePaginacao.registrosPorPagina = registrosPorPagina
      this.obterListaEstadoComarcasVinculados()
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    }
  }
}
